'use strict';
import isObject from 'lodash/isObject';
import mapValues from 'lodash/mapValues';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/skip';
import {buildInjector} from '../../_libs/angular-utils';
import {applyAutoFilter, ReduxList} from '../../_libs/redux-observable-list';
import {sortByProperty} from '../../core-utilities/filters/filterUtils';
import {SortMethod} from '../../core-utilities/filters/SortMethod';
import {SYNC_MODEL_PATH, SYNC_PATH} from '../../core-utilities/rx-utils';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {buildUserChannelSyncNotifier} from '../../auth/utils/redux-lists';
import {translateMessages} from '../utils';
import {buildActions} from './todoMessageActions';
import {TodoMessageReduxListEpics} from './todoMessageEpics';
import {buildReducers} from './todoMessageReducers';
import {logger} from './logger';

// load angular dependencies:
const dependencies = {};
export const injector = buildInjector(dependencies, [
  '$translate',
]);

export const defaultSortOptions = {
  currentMethod: SortMethod.DESCENDING.name,
  property: 'date',
};
const resourcePath = 'user-todo-messages';

/**
 * @typedef {ReduxList} TodoMessageReduxList
 * @property {TodoMessageActions} actions
 */

/**
 * @param options
 * @param targetOptions
 * @return {TodoMessageReduxList}
 */
export function buildList(options, targetOptions) {
  const matchesAutoFilter = applyAutoFilter(['message'], 1);

  const actions = buildActions(options);

  const reduxList = new ReduxList({
    ...BASE_REDUX_LIST_OPTIONS,
    pageSize: 100,
    hasParentId: false,
    useSyncUpdates: true,
    canSyncCreate: false,
    useDelete: false,
    useAutoFilter: true,
    useFilterOptions: false,
    useSortOptions: true,
    // defaultFilterOptions,
    defaultSortOptions,
    isVisible,
    applySortOptions,
    syncNotifier: buildUserChannelSyncNotifier('todo-messages', `user-todo-messages syncNotifier`),
    listPath: resourcePath,
    listSyncPath: `${resourcePath}/${SYNC_PATH}`,
    syncModelPath: `${resourcePath}/${SYNC_MODEL_PATH}`,
    getSyncModelBody,
    parseList,
    parseSyncList,
    logger,
    syncModelActionsTypes: [actions.selectAction.TYPE],
    ...options,

    // cacheOptions: {
    //   localForage: asyncStorage,
    //   key: targetOptions.cacheName,
    // },
  });

  Object.assign(reduxList.actions, actions);
  reduxList.reducers.reducer = buildReducers(reduxList);

  const todoMessageReduxListEpics = new TodoMessageReduxListEpics(reduxList);
  reduxList.epics.addEpics(todoMessageReduxListEpics.epics);

  return reduxList;

  function isVisible(item, filterData) {
    if (!isObject(item)) return false;
    if (!item.isSupported) return false;
    if (!matchesAutoFilter(item, filterData.filter)) return false;
    return true;
  }

  function parseList(list) {
    return list.reduce((acc, item) => {
      acc[item.id] = hydrateMessage(item);
      return acc;
    }, {});
  }

  function parseSyncList(list) {
    return list ? mapValues(list, hydrateSyncMessage) : list;
  }

  function hydrateMessage(item) {
    const nextItem = dependencies.$translate.isReady()
      ? translateMessages(item, dependencies.$translate, reduxList.options.logger)
      : {...item};

    switch (nextItem.type) {
      case 'invite':
      case 'invite_cancelled':
        nextItem.tagName = 'invite';
        break;

      default:
        nextItem.isSupported = false;
    }

    return nextItem;
  }

  /**
   * We only need to send the selectedAction to the server.
   * @param {Object} model
   * @return {Object}
   */
  function getSyncModelBody(model) {
    return {
      id: model.id,
      selectedAction: model.selectedAction,
    };
  }

  function hydrateSyncMessage(item) {
    return item ? hydrateMessage(item) : item;
  }
}

export function applySortOptions(list, sortOptions) {
  return list.sort(sortByProperty('date', SortMethod.ASCENDING.val, true));
}



// WEBPACK FOOTER //
// ./src/js/todo-messages/redux/todoMessagesConfig.js